// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * A storage row's Files list, opened under the row. Colours, type and
 * geometry come from ../../styles/curioTokens.css.
 */

.e9e4RXjR7ZwP8y_2g6op {
  flex-basis: 100%;
  margin-top: 8px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  overflow: hidden;
}

.G_QzgmGVWsmo2_2q0c9L {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-primary);
}

.G_QzgmGVWsmo2_2q0c9L th {
  text-align: left;
  padding: 6px 10px;
  font-size: var(--curio-font-size-xs);
  font-weight: 600;
  color: var(--curio-text-meta);
  background: var(--curio-page-bg);
  border-bottom: 1px solid var(--curio-border);
}

.G_QzgmGVWsmo2_2q0c9L td {
  padding: 4px 10px;
  border-bottom: 1px solid var(--curio-border);
  vertical-align: middle;
}

.G_QzgmGVWsmo2_2q0c9L tr:last-child td {
  border-bottom: 0;
}

/* Many path fields scroll sideways inside the panel, not past it. */
.yVe01YvJLMcsQ9ChhHBg {
  overflow-x: auto;
}

.zPimoUi9k9GfjbKUrmSQ {
  display: block;
  max-width: 320px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--curio-font-mono);
  font-size: var(--curio-font-size-xs);
}

.KvATsg185IeIVwiursVI {
  text-align: right;
  white-space: nowrap;
}

.jbIo4BsNCmLwyKLXls0w {
  display: block;
  width: 48px;
  height: 36px;
  border-radius: var(--curio-radius-sm);
  object-fit: cover;
  background: var(--curio-surface-muted);
}

.G6UG2kAVxgkxJCdatJzy {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-top: 1px solid var(--curio-border);
  background: var(--curio-page-bg);
}

.UVI6AR0mPGXt4UjmoJlC {
  flex: 1;
}

.dl0iIKoXitdCO1Lms5w7 {
  margin: 0;
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-meta);
}

.CdY8kVeOKSkS3sJ8FBe7 {
  height: 26px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  padding: 0 10px;
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
  font-weight: 600;
  cursor: pointer;
}

.CdY8kVeOKSkS3sJ8FBe7:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Dark filled = an action, matching every other catalog surface. */
.bqVs2iuV4ToFRQyQgZVd {
  height: 28px;
  border: 0;
  border-radius: var(--curio-radius-lg);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  padding: 0 12px;
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
  font-weight: 600;
  cursor: pointer;
}

.bqVs2iuV4ToFRQyQgZVd:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.GeigB39bYbA9RyIldpXV {
  flex-basis: 100%;
  margin: 8px 0 0;
  padding: 8px 10px;
  border: 1px solid var(--curio-danger-border);
  border-radius: var(--curio-radius-md);
  background: var(--curio-danger-bg);
  color: var(--curio-danger-text);
  font-size: var(--curio-font-size-sm);
}
`, "",{"version":3,"sources":["webpack://./src/pages/discovery/DiscoveryFilesPanel.module.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,qCAAqC;EACrC,kCAAkC;EAClC,+BAA+B;EAC/B,oCAAoC;AACtC","sourcesContent":["/*\n * A storage row's Files list, opened under the row. Colours, type and\n * geometry come from ../../styles/curioTokens.css.\n */\n\n.panel {\n  flex-basis: 100%;\n  margin-top: 8px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  overflow: hidden;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-primary);\n}\n\n.table th {\n  text-align: left;\n  padding: 6px 10px;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 600;\n  color: var(--curio-text-meta);\n  background: var(--curio-page-bg);\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.table td {\n  padding: 4px 10px;\n  border-bottom: 1px solid var(--curio-border);\n  vertical-align: middle;\n}\n\n.table tr:last-child td {\n  border-bottom: 0;\n}\n\n/* Many path fields scroll sideways inside the panel, not past it. */\n.tableScroll {\n  overflow-x: auto;\n}\n\n.path {\n  display: block;\n  max-width: 320px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-family: var(--curio-font-mono);\n  font-size: var(--curio-font-size-xs);\n}\n\n.size {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.thumb {\n  display: block;\n  width: 48px;\n  height: 36px;\n  border-radius: var(--curio-radius-sm);\n  object-fit: cover;\n  background: var(--curio-surface-muted);\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-top: 1px solid var(--curio-border);\n  background: var(--curio-page-bg);\n}\n\n.spacer {\n  flex: 1;\n}\n\n.note {\n  margin: 0;\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-meta);\n}\n\n.pageButton {\n  height: 26px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  padding: 0 10px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.pageButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Dark filled = an action, matching every other catalog surface. */\n.addButton {\n  height: 28px;\n  border: 0;\n  border-radius: var(--curio-radius-lg);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  padding: 0 12px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.addButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.error {\n  flex-basis: 100%;\n  margin: 8px 0 0;\n  padding: 8px 10px;\n  border: 1px solid var(--curio-danger-border);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-danger-bg);\n  color: var(--curio-danger-text);\n  font-size: var(--curio-font-size-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `e9e4RXjR7ZwP8y_2g6op`,
	"table": `G_QzgmGVWsmo2_2q0c9L`,
	"tableScroll": `yVe01YvJLMcsQ9ChhHBg`,
	"path": `zPimoUi9k9GfjbKUrmSQ`,
	"size": `KvATsg185IeIVwiursVI`,
	"thumb": `jbIo4BsNCmLwyKLXls0w`,
	"footer": `G6UG2kAVxgkxJCdatJzy`,
	"spacer": `UVI6AR0mPGXt4UjmoJlC`,
	"note": `dl0iIKoXitdCO1Lms5w7`,
	"pageButton": `CdY8kVeOKSkS3sJ8FBe7`,
	"addButton": `bqVs2iuV4ToFRQyQgZVd`,
	"error": `GeigB39bYbA9RyIldpXV`
};
export default ___CSS_LOADER_EXPORT___;
